export default [
  {
    path: "/volunteer",
    name: "volunteer",
    component: () => import("@/views/volunteer-view/layouts/Volunteer.vue"),

    children: [
      {
        path: "add-volunteer",
        name: "add-volunteer",

        component: () =>
          import("@/views/volunteer-view/pages/add-volunteer/AddVolunteer.vue"),
        children: [
          {
            path: "volunteer-table",
            name: "volunteer-table",
            // component: () => import("@/views/admin/pages/home/Home.vue"),
            component: () =>
              import(
                "@/views/volunteer-view/pages/add-volunteer/components/Volunteertable.vue"
              ),

            meta: {
              rule: "editor",
              authRequired: true,
            },
          },

          {
            path: "session-comp",
            name: "session-comp",
            // component: () => import("@/views/admin/pages/home/Home.vue"),
            component: () =>
              import(
                "@/views/volunteer-view/pages/add-volunteer/components/SessionComp.vue"
              ),

            meta: {
              rule: "editor",
              authRequired: true,
            },
          },
          {
            path: "career-req",
            name: "career-req",
            // component: () => import("@/views/admin/pages/home/Home.vue"),
            component: () =>
              import(
                "@/views/volunteer-view/pages/add-volunteer/components/CareerReq"
              ),

            meta: {
              rule: "editor",
              authRequired: true,
            },
          },
          {
            path: "earning-table",
            name: "earning-table",
            // component: () => import("@/views/admin/pages/home/Home.vue"),
            component: () =>
              import(
                "@/views/volunteer-view/pages/add-volunteer/components/Earningtable.vue"
              ),

            meta: {
              rule: "editor",
              authRequired: true,
            },
          },
        ],
      },
      {
        path: "add-edit",
        name: "add-edit",
        // component: () => import("@/views/admin/pages/home/Home.vue"),
        component: () =>
          import("@/views/volunteer-view/pages/add-edit/Addedit.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "v-setting",
        name: "v-setting",
        // component: () => import("@/views/admin/pages/home/Home.vue"),
        component: () =>
          import("@/views/volunteer-view/pages/volunteersetting/Vsetting.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
    ],
    meta: {
      rule: "editor",
      authRequired: true,
    },
  },
];
